export default "__VITE_ASSET__JhR_iEC0__"